<template>
  <v-card class="bordered-card" :id="id">
    <video
        v-if="mode === 'video'"
        style="border-radius: 15px!important; height: 97%"
        width="100%"
        :ref="reff"
        :playsinline="playsinline"
        :autoplay="autoplay"
        :controls="controls"
        :muted="muted"
        :class="mirror ? 'mirror' : ''"
    />
    <audio
        style="border-radius: 15px!important; width: 100%"
        v-else-if="mode === 'audio'"
        :ref="reff"
        :autoplay="fileSharer.id != currentUser.id"
        :controls="controls"
    />
    <v-icon v-if="mode === 'audio' && !controls" size="100px">mdi-volume-high</v-icon>
    <div class="under-video-layer">
      <v-btn v-if="fileSharer && fileSharer.id == currentUser.id" type="button" fab x-small :color="colors.success"
             class="white--text ml-1" @click="$emit('cancelFileSharing')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn type="button" fab x-small :color="colors.success" class="white--text"
             @click="$emit('toggleFullScreen', id)">
        <v-icon>mdi-fullscreen</v-icon>
      </v-btn>
      <v-chip small :class="[selfChip ? 'current-user-chip' : 'user-chip']" :color="selfChip ? colors.danger : ''">
        {{ chipText }}
      </v-chip>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MeetingSimpleCardDesktop",
  props: [
    'id',
    'muted',
    'reff',
    'colors',
    'user',
    'selfChip',
    'chipText',
    'currentUser',
    'fileSharer',
    'playsinline',
    'autoplay',
    'controls',
    'mode',
    'mirror'
  ],
}
</script>

<style scoped>
.bordered-card {
  border: 1px solid black;
  border-radius: 15px !important;
  padding: 10px 10px 40px;
  height: 100%;
}

.user-chip {
  float: left;
  margin-top: 4px;
}

.current-user-chip {
  float: left;
  margin-top: 4px;
  color: white
}

.under-video-layer {
  height: 40px;
  bottom: 0;
  position: absolute;
  padding: 0 10px;
  width: 100%;
  right: 0;
  left: 0;
  text-align: right !important;
}

.mirror {
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); /* Firefox */
}
</style>